import React, { Component } from 'react'
import { Card, List, Image } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button'

import { connect } from 'react-redux'

import { API_BASE } from '../../utils/contrains'
import { padLeft } from '../../utils/dataUtil'
import { formateDate } from '../../utils/dateUtil'
const Item = List.Item

class MyApplyCaseDetails extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    componentDidMount() {

    }

    // 遠端數據處理 //////////////////////////////////////////////



    /////////////////////////////////////////////////////////// 

    render() {
        const { CaseNid, CaseContent, CaseStatusName, RoomCode, ComputerCode, CreatorName,
            ApplyDateTime, MaintainerName, ProcessDescription, ProcessDateTime,
            RecordDescription, Appendices } = this.props.location.state.applycase

        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
                案件明細
            </span>
        )

        return (
            <Card title={title} className='my-apply-case-details'>
                <List>
                    <Item>
                        <span>
                            <span className="left">案件編號：</span>
                            <span>{'N' + padLeft(CaseNid, 7)}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件狀態：</span>
                            <span>{CaseStatusName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">申請時間：</span>
                            <span>{ApplyDateTime ? formateDate(ApplyDateTime) : ''}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件說明：</span>
                            <span>{CaseContent}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">報案人員：</span>
                            <span>{CreatorName}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件位置：</span>
                            <span>{RoomCode} / {ComputerCode}</span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">案件備註：</span>
                            <span>
                                <span dangerouslySetInnerHTML={{ __html: RecordDescription }} />
                            </span>
                        </span>
                    </Item>
                    <Item>
                        <span>
                            <span className="left">附加照片：</span>
                            <span>
                                {
                                    (Appendices) ?
                                        Appendices.map(img =>
                                        (
                                            <Image
                                                key={img.FileNid}
                                                width={150}
                                                src={API_BASE + img.FileUrl}
                                                alt="" />
                                        )
                                        ) : null
                                }
                            </span>
                        </span>
                    </Item>
                    {CaseStatusName === '案件完成' ? (
                        <span>
                            <Item >
                                <span>
                                    <span className="left">處理人員：</span>
                                    <span>{MaintainerName}</span>
                                </span>
                            </Item>
                            <Item>
                                <span>
                                    <span className="left">處理說明：</span>
                                    <span>{ProcessDescription}</span>
                                </span>
                            </Item>
                            <Item>
                                <span>
                                    <span className="left">處理時間：</span>
                                    <span>{ProcessDateTime.substring(4, 0) === '1999' ? '' : formateDate(ProcessDateTime)}</span>
                                </span>
                            </Item>
                        </span>
                    ) : ''}

                </List>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(MyApplyCaseDetails)